
// State interface
export interface RoaduseAllocationState {
    biotemplatesInAllocationStepSurplusVol: [],
    biotemplatesInAllocationStepTwo: [],
    biotemplatesInAllocationStepThree: [],
    biotemplatesInAllocationStepFour: [],
    biotemplatesInAllocationStepJointFulf: [],
    biotemplatesInAllocationStepFive: [],
}
// initialState
const initialState = {
    biotemplatesInAllocationStepSurplusVol: [],
    biotemplatesInAllocationStepTwo: [],
    biotemplatesInAllocationStepThree: [],
    biotemplatesInAllocationStepFour: [],
    biotemplatesInAllocationStepJointFulf: [],
    biotemplatesInAllocationStepFive: [],
} as RoaduseAllocationState;

// Action
const UPDATE_BIOTEMPLATES_STEP_SURPLUS_VOL = 'UPDATE_BIOTEMPLATES_STEP_SURPLUS_VOL'
const UPDATE_BIOTEMPLATES_STEP_TWO = 'UPDATE_BIOTEMPLATES_STEP_TWO'
const UPDATE_BIOTEMPLATES_STEP_THREE = 'UPDATE_BIOTEMPLATES_STEP_THREE'
const UPDATE_BIOTEMPLATES_STEP_FOUR = 'UPDATE_BIOTEMPLATES_STEP_FOUR'
const UPDATE_BIOTEMPLATES_STEP_JOINT_FULF = 'UPDATE_BIOTEMPLATES_STEP_JOINT_FULF'
const UPDATE_BIOTEMPLATES_STEP_FIVE = 'UPDATE_BIOTEMPLATES_STEP_FIVE'
const EMPTY_KEY = 'EMPTY_KEY'
// Action creator
export const updateBiotemplateStepSurplusVol = (data: any) => {
    return {
        type: UPDATE_BIOTEMPLATES_STEP_SURPLUS_VOL,
        data: data
    };
};
export const updateBiotemplateStepTwo = (data: any) => {
    return {
        type: UPDATE_BIOTEMPLATES_STEP_TWO,
        data: data
    };
};
export const updateBiotemplateStepThree = (data: any) => {
    return {
        type: UPDATE_BIOTEMPLATES_STEP_THREE,
        data: data
    };
};
export const updateBiotemplateStepFour = (data: any) => {
    return {
        type: UPDATE_BIOTEMPLATES_STEP_FOUR,
        data: data
    };
};
export const updateBiotemplateStepJointFulf = (data: any) => {
    return {
        type: UPDATE_BIOTEMPLATES_STEP_JOINT_FULF,
        data: data
    };
};
export const updateBiotemplateStepFive = (data: any) => {
    return {
        type: UPDATE_BIOTEMPLATES_STEP_FIVE,
        data: data
    };
};

export const emptyKey = () => {
    return {
        type: EMPTY_KEY,
        data: []
    };
};
// Reducer
const RoaduseAllocationReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case UPDATE_BIOTEMPLATES_STEP_SURPLUS_VOL: return {
            ...state,
            biotemplatesInAllocationStepSurplusVol: {...action.data}
        };
        case UPDATE_BIOTEMPLATES_STEP_TWO: return {
            ...state,
            biotemplatesInAllocationStepTwo: {...action.data}
        };
        case UPDATE_BIOTEMPLATES_STEP_THREE: return {
            ...state,
            biotemplatesInAllocationStepThree: {...action.data}
        };
        case UPDATE_BIOTEMPLATES_STEP_FOUR: return {
            ...state,
            biotemplatesInAllocationStepFour: {...action.data}
        };
        case UPDATE_BIOTEMPLATES_STEP_JOINT_FULF: return {
            ...state,
            biotemplatesInAllocationStepJointFulf: {...action.data}
        };
        case UPDATE_BIOTEMPLATES_STEP_FIVE: return {
            ...state,
            biotemplatesInAllocationStepFive: {...action.data}
        };

        case EMPTY_KEY: return{
            biotemplatesInAllocationStepSurplusVol: [],
            biotemplatesInAllocationStepTwo: [],
            biotemplatesInAllocationStepThree: [],
            biotemplatesInAllocationStepFour: [],
            biotemplatesInAllocationStepJointFulf: [],
            biotemplatesInAllocationStepFive: [],
        };

        default: return state;
    }
};

export default RoaduseAllocationReducer;
